import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/edi/batchsftpprocess'
import pathMap from 'src/paths/PathMap_EDI'

class BatchSftpProcessRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.BATCH_SFTP_PROCESS_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.BATCH_SFTP_PROCESS_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.BATCH_SFTP_PROCESS_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.BATCH_SFTP_PROCESS_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default BatchSftpProcessRoute
